import { Button, Card, CardContent, Grid, Typography } from "@material-ui/core";

const Standards = () => {
  return (
    <Card mb={6}>
      <CardContent>
        <Grid container direction="column" spacing={6}>
          <Grid item>
            <Typography variant="h5">Standards</Typography>
          </Grid>
          <Grid item style={{ marginTop: 10 }}>
            <Typography variant="body1" style={{ fontSize: "14px"}}>
              <b>ANSI/AARST MAH-2023</b> “Protocol for Conducting Measurements of Radon and Radon Decay Products in Homes”<br/>
              <a href={"https://standards.aarst.org/MAH-2023/index.html#zoom=z"} target={"_blank"}>https://standards.aarst.org/MAH-2023/index.html#zoom=z</a>
            </Typography>
            <Typography variant="body1" style={{ fontSize: "14px", marginTop: 12 }}>
              <b>ANSI/AARST MA-MFLB-2023</b> “Protocol for Conducting Measurements of Radon and Radon
              Decay Products in Multifamily, School, Commercial and Mixed-Use Buildings”<br/>
              <a href={"https://standards.aarst.org/MA-MFLB-2023/index.html#zoom=z"} target={"_blank"}>https://standards.aarst.org/MA-MFLB-2023/index.html#zoom=z</a>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Standards;
